document.addEventListener('DOMContentLoaded', function() {
    // Replace 'YOUR_API_KEY' with your actual API key from the geolocation service
    fetch('https://api.ipstack.com/check?access_key=YOUR_API_KEY')
        .then(response => response.json())
        .then(data => {
            var blockedRegions = [
                // List of blocked regions, for example, Africa and Middle East ISO codes
                'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CV', 'CF', 'TD', 'KM', 'CG', 'CD', 'DJ', 'EG', 'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'CI', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'YT', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'TZ', 'TG', 'TN', 'UG', 'EH', 'ZM', 'ZW', // Africa
                'AF', 'AM', 'AZ', 'BH', 'CY', 'GE', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'OM', 'PS', 'QA', 'SA', 'SY', 'TR', 'AE', 'YE' // Middle East
            ];

            if (blockedRegions.includes(data.country_code)) {
                document.body.innerHTML = '<h1>Access Denied</h1><p>Unfortunately, our services are not available in your region.</p>';
            }
        })
        .catch(error => console.error('Error fetching geolocation data:', error));
});
